// "Does this location's cart need a kickoff/onboarding call?" — the gate
// Catalog Selection's Continue button uses to route to the Scheduling step
// vs. straight to Payment Details (see getSchedulingLocations, which applies
// this PER LOCATION for Multi-location Parent Pay).
//
// The rule itself lives in utils/scheduling-call-rules.js and is the SAME one
// the Proposal Tool's client flow uses (isScheduleCallRequired), so both new
// flows agree on which products need a call. That rule covers:
//   • any newly added non-exempt CENTER (BC/MC/Keap/Premier/Workforce/...)
//   • MC Signature's "onboarding required?" choice + bundled website override
//   • Thryv Starter's Growth Package "Include Onboarding?" opt-in
//   • kickoff entitlements newly added to an already-owned center
//   • the explicit app / add-on / one-time / Social Ads code lists
//   • Strategic Content Creation → a separate Thryv Success Services call
//     (SchedulingStep shows one scheduler per named call — see
//     getRequiredCallTypes)
// and documents what is deliberately NOT ported from the legacy
// screens/onboarding-program.js rule (name/groupTitle catch-all).
//
// items: a flat array of ONE PurchaseLinkSlice location's `items` — only
// newly-added (!alreadyIncluded) items count, matching comparePlans'
// "selected but not already present" semantics.
import {itemsRequireScheduleCall} from '../../../../utils/scheduling-call-rules'
import {
  isKeapPartnerSchedulingRole,
  keapPartnerItemsRequireScheduleCall,
} from './keapPartnerSchedulingRules'

// isTgpUpgradeEnabled: GEP-7133 / FULSAS-13599 — forwarded straight through
// to itemsRequireScheduleCall's own isTgpUpgradeEnabled option. Defaults to
// false, matching that function's default, so an omitted flag is a no-op.
export function shouldRequireOnboardingCall(
  items = [],
  {roles = [], isTgpUpgradeEnabled = false} = {},
) {
  if (isKeapPartnerSchedulingRole(roles)) {
    return keapPartnerItemsRequireScheduleCall(items, {roles})
  }
  return itemsRequireScheduleCall(items, {isTgpUpgradeEnabled})
}
